module.exports = __webpack_public_path__ + "media/images/athletes/3505-78812b210014098c58371cf6eef2d0c6.png";